export const TRADING_PLATFORM_AGREEMENTS_SEARCH =
  'TRADING_PLATFORM_AGREEMENTS_SEARCH';
